/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-loop-func */
import { useState, useEffect, useRef, useCallback } from "react";
// ─── FIREBASE — imports npm ───────────────────────────────────────────────────
import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { HomePage, CreateProgramPage, GenerateProgramPage } from './HomePage.js';
import TutorialPage from './TutorialPage.js';
import { RestTimer, SetModal, AddCustomExModal, ExPicker, SessionPage } from './SessionPage.js';
import { TabataRunPage, TabataPage, GenerateTabataPage, CreateTabataPage } from './TabataPages.js';
import { MeasModal, StatsPage, SessionSummaryPage, HistoryPage, SeriesProgressPage, ExercicesBasePage, SuiviPage } from './SuiviPages.js';
import ShareCard from './ShareCard.js';
import ShareCardTabata from './ShareCardTabata.js';
import html2canvas from 'html2canvas';

import { ProfilePage, THEMES } from './ProfilePage.js';
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";

import { EXERCISE_DATABASE, EX, EXERCISE_GUIDE, EXERCISE_CATEGORIES, getExCategorie, TABATA_EX_BASE } from './exercises.js';
import { getMedal as getMedalByLevel } from './medalsLogic.js';
import { calcSessionXP, calcTabataXP, calcPRXP, getLevelFromXP, recalcTotalXP } from './xpSystem.js';
import { getMascotMessage } from './mascotMessages.js';
import { generateAdaptedPrograms, getAvailableExercises, adaptExercise } from './programGenerator.js';
import { LOGO_LIGHT_DATA, MASCOT_BUST_DATA } from './assets.js';

const firebaseConfig = {
  apiKey: "AIzaSyBcg2R6iR45ljN2JGuMRl4YeXnkEmTobMk",
  authDomain: "bearforge-33a7d.firebaseapp.com",
  projectId: "bearforge-33a7d",
  storageBucket: "bearforge-33a7d.firebasestorage.app",
  messagingSenderId: "772011440598",
  appId: "1:772011440598:web:1ff82bf8c5cc0c34668c77"
};

const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const fbAuth = getAuth(firebaseApp);
const fbDb = getFirestore(firebaseApp);
const googleProvider = new GoogleAuthProvider();

// ─── LOCALSTORAGE KEYS ────────────────────────────────────────────────────────
const LS_KEY = 'bf-data';
const LS_SESSION_KEY = 'calestan_session_state';
const LS_TABATA_KEY = 'bf-tabata';

// THEMES importé depuis ProfilePage.js
const makeC = (t, dark=true) => dark ? {
  bg:"#080808", surface:"#101010", card:"#161616", border:"#222222",
  accent:t.a, accent2:t.b, glow:t.a+"33",
  text:"#F2F2EF", muted:"#A0A0A0", faint:"#1E1E1E",
  green:"#22c55e", red:"#ef4444", yellow:"#eab308", isDark:true,
} : {
  bg:"#F5F5F0", surface:"#FFFFFF", card:"#FFFFFF", border:"#E0E0DC",
  accent:t.a, accent2:t.b, glow:t.a+"33",
  text:"#1A1A1A", muted:"#606060", faint:"#EBEBEB",
  green:"#16a34a", red:"#dc2626", yellow:"#ca8a04", isDark:false,
};

const MM = {
  "Pectoraux":{color:"#ef4444",bg:"rgba(239,68,68,0.12)"},
  "Dos":{color:"#8b5cf6",bg:"rgba(139,92,246,0.12)"},
  "Épaules":{color:"#eab308",bg:"rgba(234,179,8,0.12)"},
  "Biceps":             {color:"#f97316",bg:"rgba(249,115,22,0.12)"},
  "Triceps":            {color:"#06b6d4",bg:"rgba(6,182,212,0.12)"},
  "Quadriceps":         {color:"#3b82f6",bg:"rgba(59,130,246,0.12)"},
  "Ischio-jambiers":    {color:"#10b981",bg:"rgba(16,185,129,0.12)"},
  "Fessiers":           {color:"#ec4899",bg:"rgba(236,72,153,0.12)"},
  "Mollets":            {color:"#14b8a6",bg:"rgba(20,184,166,0.12)"},
  "Abdominaux":         {color:"#f59e0b",bg:"rgba(245,158,11,0.12)"},
  "Trapèzes":           {color:"#a78bfa",bg:"rgba(167,139,250,0.12)"},
  "Avant-bras":         {color:"#fb923c",bg:"rgba(251,146,60,0.12)"},
  "Cardio / Full body": {color:"#84cc16",bg:"rgba(132,204,22,0.12)"},
};

// Règles de substitution pour équipement maison (57 règles)
// ─── EXERCISE DATABASE WITH SMART ALTERNATIVES ────────────────────────────
// Base de données complète des exercices avec alternatives selon équipement
// Ordre des alternatives : plus d'équipement → moins d'équipement → poids du corps
// ─── COMPLETE EXERCISE DATABASE ───────────────────────────────────────────
// Base de données des exercices avec alternatives selon équipement disponible

// ─── COMPLETE EXERCISE DATABASE ───────────────────────────────────────────
// Base de données COMPLÈTE des exercices avec alternatives selon équipement
// 
// RÈGLES DE CATÉGORISATION:
// - MACHINE = salle uniquement (Presse, Leg curl, Leg extension, Butterfly, etc.)
// - POULIE/CÂBLE = salle uniquement (Tirage, Élévations poulie, Triceps poulie, etc.)
// - BARRE = needs ["barre"] (Développé couché barre, Squat barre, Curl barre, etc.)
// - HALTÈRES = needs ["halteres"] (Développé haltères, Curl haltères, etc.)
// - BARRE TRACTION = needs ["barre_traction"] (Tractions)
// - POIDS DU CORPS = needs [] (Pompes, Dips, Squats PDC, etc.)

// Fonction pour filtrer les exercices disponibles selon l'équipement
// getAvailableExercises et adaptExercise sont maintenant dans programGenerator.js

const MENSURATION_KEYS = [
  {k:"chest",label:"Poitrine"},{k:"waist",label:"Taille"},{k:"hips",label:"Hanches"},
  {k:"leftArm",label:"Biceps gauche"},{k:"rightArm",label:"Biceps droit"},
  {k:"leftThigh",label:"Cuisse gauche"},{k:"rightThigh",label:"Cuisse droite"},
  {k:"leftCalf",label:"Mollet gauche"},{k:"rightCalf",label:"Mollet droit"},
  {k:"neck",label:"Cou"},{k:"shoulders",label:"Épaules"},
];

const ALL_MUSCLES = [...new Set(EX.map(e=>e.muscle))];

const fmt = s => `${Math.floor(s/60)}:${(s%60).toString().padStart(2,"0")}`;
const fmtRest = s => s>=60 ? `${Math.floor(s/60)}m${s%60>0?" "+(s%60)+"s":""}` : `${s}s`;

// ─── AUDIO ────────────────────────────────────────────────────────────────────
let _ctx = null;
const getCtx = () => {
  if (!_ctx || _ctx.state === "closed") _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
};
if (typeof window !== "undefined") {
  const unlock = () => {
    try { if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)(); if (_ctx.state === "suspended") _ctx.resume(); } catch(e) {}
    document.removeEventListener("touchstart", unlock);
    document.removeEventListener("click", unlock);
  };
  document.addEventListener("touchstart", unlock, { passive: true });
  document.addEventListener("click", unlock);
}
const beep = (freq, dur, vol=0.4, type="sine") => {
  try {
    const c = getCtx(); const o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination); o.frequency.value = freq; o.type = type;
    const t = c.currentTime;
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t+dur);
    o.start(t); o.stop(t+dur+0.01);
  } catch(e) {}
};
// Audio ducking : baisse la musique externe pendant les bips
let musicVolume = 1.0;
const duckAudio = (duck) => {
  try {
    if ('mediaSession' in navigator) {
      // On ne peut pas contrôler directement le volume de la musique externe
      // mais on peut utiliser l'API Media Session pour indiquer qu'on joue un son
      navigator.mediaSession.playbackState = duck ? 'playing' : 'paused';
    }
  } catch(e) {}
};

// Nouveau système de countdown unifié : bip à 3s, 2s, 1s, puis long bip
const playCountdown = (secondsRemaining) => {
  try {
    const c = getCtx();
    const freq = 600;
    
    if (secondsRemaining === 3 || secondsRemaining === 2 || secondsRemaining === 1) {
      // Bips courts identiques (bip bip bip)
      duckAudio(true);
      const o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.frequency.value = freq;
      o.type = "square";
      const t = c.currentTime;
      g.gain.setValueAtTime(0.6, t);
      g.gain.exponentialRampToValueAtTime(0.001, t+0.15);
      o.start(t);
      o.stop(t+0.18);
      setTimeout(() => duckAudio(false), 180);
    } else if (secondsRemaining === 0) {
      // Bip long final - MÊME FRÉQUENCE mais plus long (biiiiiiiip)
      duckAudio(true);
      const o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.frequency.value = freq; // MÊME tonalité
      o.type = "square";
      const t = c.currentTime;
      g.gain.setValueAtTime(0.7, t); // Un peu plus fort
      g.gain.exponentialRampToValueAtTime(0.001, t+0.8);
      o.start(t);
      o.stop(t+0.85); // Plus long
      setTimeout(() => duckAudio(false), 850);
    }
  } catch(e) {}
};

const playFinish = () => {
  try {
    duckAudio(true);
    const c = getCtx();
    const o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination);
    o.frequency.value = 880;
    o.type = "sine";
    const t = c.currentTime;
    g.gain.setValueAtTime(0.7, t);
    g.gain.setValueAtTime(0.7, t+1.5);
    g.gain.exponentialRampToValueAtTime(0.001, t+2.2);
    o.start(t);
    o.stop(t+2.3);
    setTimeout(() => duckAudio(false), 2300);
  } catch(e) {}
};
const playTransition = () => beep(330, 0.3, 0.5, "sine");
const speak = t => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(t);
  u.lang = "fr-FR"; u.rate = 0.95;
  window.speechSynthesis.speak(u);
};

// ─── UI ATOMS ─────────────────────────────────────────────────────────────────
const Tag = ({label,color,bg}) => (
  <span style={{background:bg,color,fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:700}}>{label}</span>
);
// ─── TOAST NOTIFICATION ──────────────────────────────────────────────────────
// Usage : window.__bearToast?.("Message", "error"|"success"|"info")
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  useEffect(()=>{
    window.__bearToast = (msg, type="info") => {
      const id = Date.now();
      setToasts(p=>[...p, {id, msg, type}]);
      setTimeout(()=>setToasts(p=>p.filter(t=>t.id!==id)), 3200);
    };
    return ()=>{ delete window.__bearToast; };
  },[]);
  if(!toasts.length) return null;
  return(
    <div style={{position:"fixed",top:52,left:0,right:0,zIndex:999,display:"flex",flexDirection:"column",alignItems:"center",gap:8,pointerEvents:"none",padding:"0 20px"}}>
      {toasts.map(t=>(
        <div key={t.id} style={{
          background:t.type==="error"?"rgba(239,68,68,0.95)":t.type==="success"?"rgba(34,197,94,0.95)":"rgba(30,30,30,0.95)",
          color:"white",borderRadius:12,padding:"11px 18px",fontSize:13,fontWeight:700,
          boxShadow:"0 4px 20px rgba(0,0,0,0.3)",backdropFilter:"blur(8px)",
          maxWidth:320,textAlign:"center",lineHeight:1.4
        }}>{t.msg}</div>
      ))}
    </div>
  );
};
const showToast = (msg, type="info") => window.__bearToast?.(msg, type);

const mkBtn = C => ({children,onClick,variant="primary",small,full,disabled,style:s={}}) => {
  const v = {
    primary:{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,color:"white",boxShadow:`0 4px 20px ${C.glow}`},
    ghost:  {background:C.faint,color:C.muted,border:`1px solid ${C.border}`},
    outline:{background:"transparent",color:C.accent,border:`1px solid ${C.accent}`},
    danger: {background:"rgba(239,68,68,0.1)",color:C.red,border:"1px solid rgba(239,68,68,0.25)"},
  };
  return <button onClick={disabled?undefined:onClick} style={{border:"none",fontWeight:800,borderRadius:12,cursor:disabled?"default":"pointer",opacity:disabled?0.35:1,fontSize:small?13:15,letterSpacing:0.4,padding:small?"8px 16px":"14px 20px",width:full?"100%":undefined,transition:"all 0.15s",...v[variant],...s}}>{children}</button>;
};
const ConfirmModal = ({message,onConfirm,onCancel,confirmLabel,cancelLabel,C}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:"0 24px"}}>
    <div style={{background:C.card,borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:380,border:`1px solid ${C.border}`}}>
      <p style={{color:C.text,fontWeight:800,fontSize:17,margin:"0 0 8px",textAlign:"center"}}>Confirmer</p>
      <p style={{color:C.muted,fontSize:14,margin:"0 0 24px",textAlign:"center",lineHeight:1.5}}>{message}</p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <button onClick={onCancel} style={{padding:"12px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.muted,fontWeight:800,cursor:"pointer"}}>{cancelLabel||"Annuler"}</button>
        <button onClick={onConfirm} style={{padding:"12px",background:confirmLabel?"rgba(59,130,246,0.12)":"rgba(239,68,68,0.12)",border:confirmLabel?"1px solid rgba(59,130,246,0.3)":"1px solid rgba(239,68,68,0.3)",borderRadius:12,color:confirmLabel?C.accent:C.red,fontWeight:800,cursor:"pointer"}}>{confirmLabel||"Supprimer"}</button>
      </div>
    </div>
  </div>
);

// ─── LINE CHART SVG ───────────────────────────────────────────────────────────
// Courbe à points et lignes — remplace tous les graphiques en barres
function LineChart({data, valueKey="val", labelKey="date", height=88, accentColor, mutedColor, cardBg, borderColor, compact=false}) {
  if(!data||data.length<2) return null;
  const vals = data.map(d=>d[valueKey]);
  const minV = Math.min(...vals);
  const maxV = Math.max(...vals);
  const range = maxV-minV || 1;
  const W = 300, H = compact ? 38 : height-24;
  const pad = compact ? 6 : 10;
  const n = data.length;
  const xs = data.map((_,i)=> pad + (i/(n-1))*(W-pad*2));
  const ys = vals.map(v=> H - pad - ((v-minV)/range)*(H-pad*2));
  // Polyline path
  const pts = xs.map((x,i)=>`${x},${ys[i]}`).join(" ");
  // Area fill path
  const areaPath = `M ${xs[0]},${ys[0]} ` + xs.slice(1).map((x,i)=>`L ${x},${ys[i+1]}`).join(" ") + ` L ${xs[n-1]},${H-pad} L ${xs[0]},${H-pad} Z`;

  if(compact) {
    return (
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} style={{display:"block",overflow:"visible"}}>
        <defs>
          <linearGradient id="cgA" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={accentColor} stopOpacity="0.25"/>
            <stop offset="100%" stopColor={accentColor} stopOpacity="0"/>
          </linearGradient>
        </defs>
        <path d={areaPath} fill="url(#cgA)"/>
        <polyline points={pts} fill="none" stroke={accentColor} strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round"/>
        {xs.map((x,i)=>(
          <circle key={i} cx={x} cy={ys[i]} r={i===n-1?4:2.5}
            fill={i===n-1?accentColor:cardBg||"#1a1a1a"} stroke={i===n-1?accentColor:accentColor+"88"} strokeWidth="1.5"/>
        ))}
      </svg>
    );
  }

  return (
    <svg viewBox={`0 0 ${W} ${H+24}`} width="100%" height={H+24} style={{display:"block",overflow:"visible"}}>
      <defs>
        <linearGradient id="lgA" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={accentColor} stopOpacity="0.3"/>
          <stop offset="100%" stopColor={accentColor} stopOpacity="0"/>
        </linearGradient>
      </defs>
      {/* Grille horizontale légère */}
      {[0.25,0.5,0.75].map((f,i)=>(
        <line key={i} x1={pad} y1={pad+(1-f)*(H-pad*2)} x2={W-pad} y2={pad+(1-f)*(H-pad*2)}
          stroke={borderColor||"#333"} strokeWidth="0.5" strokeDasharray="3,4" opacity="0.5"/>
      ))}
      {/* Zone remplie */}
      <path d={areaPath} fill="url(#lgA)"/>
      {/* Ligne courbe */}
      <polyline points={pts} fill="none" stroke={accentColor} strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round"/>
      {/* Points + valeurs */}
      {xs.map((x,i)=>{
        const isLast = i===n-1;
        return (
          <g key={i}>
            <circle cx={x} cy={ys[i]} r={isLast?5:3.5}
              fill={isLast?accentColor:cardBg||"#1a1a1a"} stroke={isLast?accentColor:accentColor+"99"} strokeWidth="2"/>
            {isLast&&<circle cx={x} cy={ys[i]} r={8} fill={accentColor} opacity="0.15"/>}
            <text x={x} y={ys[i]-9} textAnchor="middle" fontSize="9" fill={isLast?accentColor:mutedColor||"#666"} fontWeight={isLast?"700":"400"}>
              {vals[i]}
            </text>
            <text x={x} y={H+18} textAnchor="middle" fontSize="9" fill={mutedColor||"#666"}>
              {data[i][labelKey]}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

function MovementGuide({exercise, onClose, C, inlineMode=false}) {
  // Support both {name, detail} objects and plain string (from inlineMode usage)
  const exName = typeof exercise === "string" ? exercise : exercise?.name;
  const exDetail = typeof exercise === "string" ? null : exercise?.detail;
  const guide = EXERCISE_GUIDE[exName];
  
  // Exercices sensibles nécessitant un avertissement de sécurité
  const riskyExercises = [
    "Squat barre",
    "Squat avant",
    "Développé couché barre",
    "Développé couché haltères",
    "Développé incliné barre",
    "Soulevé de terre",
    "Soulevé de terre roumain",
    "Développé militaire barre",
    "Back squat",
    "Front squat",
    "Nordic curl",
    "Toes to bar",
    "Pompes claquées",
    "Fentes bulgares",
    "Snatch kettlebell",
  ];
  
  const isRisky = riskyExercises.some(r => exName?.toLowerCase().includes(r.toLowerCase()));

  const content = (
    <div style={{padding: inlineMode?"0":"0 20px 60px"}}>
      {!inlineMode&&(
        <div style={{background:C.faint,borderRadius:16,marginBottom:16,height:160,border:`1px solid ${C.border}`}}/>

      )}

      {exDetail&&(
        <div style={{background:`${C.accent}12`,borderRadius:12,padding:"10px 14px",marginBottom:16,border:`1px solid ${C.accent}30`}}>
          <p style={{color:C.accent,fontWeight:700,fontSize:11,margin:"0 0 3px",letterSpacing:1}}>MUSCLES CIBLÉS</p>
          <p style={{color:C.text,fontSize:13,margin:0,lineHeight:1.5}}>{exDetail}</p>
        </div>
      )}

      {guide ? (
        <>
          <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 12px"}}>EXÉCUTION</p>
          <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
            {guide.steps.map((step,i)=>(
              <div key={i} style={{display:"flex",gap:12,alignItems:"flex-start"}}>
                <div style={{width:26,height:26,borderRadius:"50%",background:`${C.accent}20`,border:`1px solid ${C.accent}50`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                  <span style={{color:C.accent,fontSize:12,fontWeight:900}}>{i+1}</span>
                </div>
                <p style={{color:C.text,fontSize:14,lineHeight:1.55,margin:0,flex:1}}>{step}</p>
              </div>
            ))}
          </div>
          <div style={{background:C.card,borderRadius:12,padding:"12px 14px",border:`1px solid ${C.border}`,display:"flex",gap:10,alignItems:"flex-start",marginBottom:isRisky?12:0}}>
            <p style={{color:C.muted,fontSize:13,margin:0,lineHeight:1.55}}>{guide.tips}</p>
          </div>
          {isRisky&&(
            <div style={{background:"#FEE",borderRadius:12,padding:"12px 14px",border:"2px solid #F44",display:"flex",gap:10,alignItems:"flex-start"}}>
              <div>
                <p style={{color:"#C00",fontWeight:800,fontSize:13,margin:"0 0 4px"}}>ATTENTION - Exercice à risque</p>
                <p style={{color:"#800",fontSize:12,margin:0,lineHeight:1.55}}>Cet exercice présente des risques accrus de blessure. Assurez-vous de maîtriser parfaitement la technique avant d'augmenter les charges. En cas de doute, demandez conseil à un coach.</p>
              </div>
            </div>
          )}
        </>
      ):(
        <div style={{background:C.card,borderRadius:12,padding:"16px",border:`1px solid ${C.border}`}}>
          <p style={{color:C.muted,fontSize:13,margin:0,lineHeight:1.6}}>Description bientôt disponible.</p>
        </div>
      )}
    </div>
  );

  if(inlineMode){
    return(
      <div style={{background:C.card,borderRadius:18,border:`1px solid ${C.accent}30`,padding:"16px",marginBottom:16}}>
        <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 12px",fontWeight:700}}>COMMENT RÉALISER CET EXERCICE</p>
        {content}
      </div>
    );
  }
  
  return (
    <div style={{position:"fixed",inset:0,background:C.bg,zIndex:500,display:"flex",flexDirection:"column",overflowY:"auto"}}>
      <div style={{background:`linear-gradient(180deg,${C.accent}18,transparent)`,padding:"48px 20px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{flex:1,minWidth:0,paddingRight:12}}>
          <p style={{color:C.accent,fontSize:10,letterSpacing:3,margin:"0 0 6px",fontWeight:700}}>COMMENT RÉALISER</p>
          <h2 style={{color:C.text,fontSize:20,fontWeight:900,margin:0,lineHeight:1.3}}>{exName}</h2>
        </div>
        <button onClick={onClose} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:"50%",width:40,height:40,color:C.text,fontSize:22,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>×</button>
      </div>
      {content}
    </div>
  );
}


// ─── LOGIN / ONBOARDING (reste dans App.js) ─────────────────────────────────
function LoginPage({onLogin, onGuest, C}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogle = async () => {
    setLoading(true);
    setError(null);
    try {
      await signInWithPopup(fbAuth, googleProvider);
    } catch(e) {
      setError("Connexion impossible. Réessaie.");
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"0 28px"}}>
      <img src={LOGO_LIGHT_DATA} alt="Calestan" style={{height:110,objectFit:"contain",marginBottom:32}}/>
      <h1 style={{color:C.text,fontWeight:900,fontSize:28,margin:"0 0 8px",textAlign:"center",letterSpacing:-0.5}}>Calestan</h1>
      <p style={{color:C.muted,fontSize:15,margin:"0 0 48px",textAlign:"center",lineHeight:1.5}}>Ton coach fitness intelligent</p>

      <div style={{width:"100%",maxWidth:340,display:"flex",flexDirection:"column",gap:14}}>
        <button onClick={handleGoogle} disabled={loading}
          style={{width:"100%",padding:"15px 20px",background:"white",border:"1px solid #e2e8f0",borderRadius:14,display:"flex",alignItems:"center",justifyContent:"center",gap:12,cursor:loading?"default":"pointer",opacity:loading?0.7:1,boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>
          {/* Google logo SVG */}
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.35-8.16 2.35-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          <span style={{color:"#1a1a1a",fontWeight:700,fontSize:15}}>
            {loading ? "Connexion..." : "Continuer avec Google"}
          </span>
        </button>

        {error && <p style={{color:C.red,fontSize:13,textAlign:"center",margin:0}}>{error}</p>}
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{flex:1,height:1,background:C.border}}/>
          <span style={{color:C.muted,fontSize:12}}>ou</span>
          <div style={{flex:1,height:1,background:C.border}}/>
        </div>

        <button onClick={onGuest}
          style={{width:"100%",padding:"15px 20px",background:"none",border:`1px solid ${C.border}`,borderRadius:14,color:C.muted,fontWeight:700,fontSize:15,cursor:"pointer"}}>
          Continuer sans compte
        </button>
      </div>

      <p style={{color:C.muted,fontSize:11,marginTop:40,textAlign:"center",lineHeight:1.6,maxWidth:280}}>
        En continuant, tu acceptes nos conditions d'utilisation et notre politique de confidentialité.
      </p>
    </div>
  );
}

// ─── ONBOARDING ───────────────────────────────────────────────────────────────
// ─── TUTORIAL PAGE ────────────────────────────────────────────────────────
function OnboardingPage({onComplete,onSkip,C}) {
  const [step,setStep]=useState(0);
  // Step 0 : Disclaimer légal (obligatoire)
  // Step 1 : Infos personnelles
  // Step 2 : Lieu d'entraînement + équipement maison
  // Step 3 : Niveau, objectif, jours
  // Step 4 : Tutorial (optionnel)

  const [disclaimerAccepted,setDisclaimerAccepted]=useState(false);
  const [firstName,setFirstName]=useState("");
  const [age,setAge]=useState("");
  const [weight,setWeight]=useState("");
  const [height,setHeight]=useState("");
  const [gender,setGender]=useState(null);
  const [location,setLocation]=useState(null);      // "salle" | "maison"
  const [homeEquip,setHomeEquip]=useState([]);       // équipements cochés si maison
  const [duration,setDuration]=useState(null); // 30|45|60|75|90 minutes
  const [days,setDays]=useState(null);
  const [fitnessGoal,setFitnessGoal]=useState(null); // "force"|"hypertrophie"|"endurance"

  const canNext1=firstName.trim().length>0&&gender!==null;
  const canNext2=location!==null;
  const canNext3=duration&&days;

  const toggleEquip=(id)=>setHomeEquip(p=>p.includes(id)?p.filter(e=>e!==id):[...p,id]);

  const handleFinish=(wantsTutorial)=>{
    const profile={
      name:firstName.trim()||null,
      age:age?parseInt(age):null,
      weight:weight?parseFloat(weight):null,
      height:height?parseInt(height):null,
      gender:gender||null,
      duration,days,
      equipment:location||"salle",
      homeEquip:location==="maison"?homeEquip:[],
      fitnessGoal:fitnessGoal||null,
    };
    onComplete(profile,wantsTutorial);
  };

  const dotIdx=step-1;
  const dots=(
    <div style={{display:"flex",gap:7,justifyContent:"center",marginBottom:32}}>
      {[0,1,2,3].map(i=>(
        <div key={i} style={{width:i===dotIdx?22:8,height:8,borderRadius:4,
          background:i===dotIdx?C.accent:i<dotIdx?`${C.accent}60`:C.faint,
          transition:"all 0.3s"}}/>
      ))}
    </div>
  );

  // ── STEP 0 : Disclaimer légal ────────────────────────────────────────────
  if(step===0) return(
    <div style={{background:C.bg,height:"100vh",display:"flex",flexDirection:"column",padding:"calc(env(safe-area-inset-top) + 20px) 24px calc(env(safe-area-inset-bottom) + 30px)",boxSizing:"border-box"}}>
      <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"center"}}>
        <img src={LOGO_LIGHT_DATA} alt="Calestan" style={{height:60,objectFit:"contain",marginBottom:20,alignSelf:"center"}}/>
        <h1 style={{color:C.text,fontSize:20,fontWeight:900,margin:"0 0 16px",textAlign:"center"}}>Avertissement Important</h1>
        
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"16px",marginBottom:20}}>
          <p style={{color:C.text,fontSize:12,lineHeight:1.6,margin:"0 0 12px"}}>
            <strong>Avant de commencer,</strong> veuillez lire attentivement :
          </p>
          <p style={{color:C.muted,fontSize:11,lineHeight:1.55,margin:"0 0 10px"}}>
            • La musculation comporte des risques de blessures. Consultez un professionnel de santé avant de débuter.
          </p>
          <p style={{color:C.muted,fontSize:11,lineHeight:1.55,margin:"0 0 10px"}}>
            • Cette application fournit des suggestions à titre informatif uniquement.
          </p>
          <p style={{color:C.muted,fontSize:11,lineHeight:1.55,margin:"0 0 10px"}}>
            • Écoutez votre corps et arrêtez en cas de douleur anormale.
          </p>
          <p style={{color:C.muted,fontSize:11,lineHeight:1.55,margin:"0"}}>
            • Les exercices avec barres et charges lourdes nécessitent une technique appropriée.
          </p>
        </div>

        <button onClick={()=>setDisclaimerAccepted(!disclaimerAccepted)}
          style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",background:C.faint,border:`2px solid ${disclaimerAccepted?C.accent:C.muted}`,borderRadius:12,cursor:"pointer"}}>
          <div style={{width:28,height:28,borderRadius:8,border:`3px solid ${disclaimerAccepted?C.accent:C.muted}`,background:disclaimerAccepted?C.accent:"transparent",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
            {disclaimerAccepted&&<span style={{color:"white",fontSize:16,fontWeight:900}}>✓</span>}
          </div>
          <span style={{color:C.text,fontSize:12,lineHeight:1.4,textAlign:"left"}}>
            J'ai lu et compris ces informations. Je m'engage à pratiquer en sécurité.
          </span>
        </button>
      </div>

      <button onClick={()=>{if(disclaimerAccepted)setStep(1);}} 
        style={{width:"100%",padding:"16px",background:disclaimerAccepted?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:16,color:disclaimerAccepted?"white":C.muted,fontWeight:800,fontSize:16,cursor:disclaimerAccepted?"pointer":"default",boxShadow:disclaimerAccepted?`0 6px 24px ${C.glow}`:"none",transition:"all 0.2s",marginTop:20}}>
        Continuer
      </button>
    </div>
  );

  // ── STEP 1 : Infos personnelles ──────────────────────────────────────────
  if(step===1) return(
    <div style={{background:C.bg,height:"100vh",display:"flex",flexDirection:"column",padding:0,boxSizing:"border-box"}}>
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 24px 0",flexShrink:0}}>
        <button onClick={()=>setStep(0)} style={{background:"none",border:"none",color:C.muted,fontSize:22,cursor:"pointer",alignSelf:"flex-start",padding:0,marginBottom:8}}>←</button>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"0 24px"}}>
        <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 3px"}}>ÉTAPE 1 / 4</p>
        <h2 style={{color:C.text,fontSize:20,fontWeight:900,margin:"0 0 3px"}}>Dis-nous qui tu es</h2>
        <p style={{color:C.muted,fontSize:12,margin:"0 0 16px"}}>Ces infos personnalisent ton programme.</p>

        {/* Prénom */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:5}}>PRÉNOM *</label>
        <input value={firstName} onChange={e=>setFirstName(e.target.value)} placeholder="Ton prénom..."
          style={{width:"100%",background:C.faint,border:`1px solid ${firstName.trim()?C.accent:C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"10px 14px",outline:"none",boxSizing:"border-box",marginBottom:12}}/>

        {/* Sexe */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:5}}>SEXE *</label>
        <div style={{display:"flex",gap:8,marginBottom:12}}>
          {[{id:"homme",label:"Homme"},{id:"femme",label:"Femme"}].map(s=>(
            <button key={s.id} onClick={()=>setGender(s.id)}
              style={{flex:1,padding:"10px 6px",borderRadius:12,border:`1px solid ${gender===s.id?C.accent:C.border}`,background:gender===s.id?`${C.accent}15`:C.faint,color:gender===s.id?C.accent:C.muted,fontWeight:700,fontSize:13,cursor:"pointer",transition:"all 0.15s"}}>
              {s.label}
            </button>
          ))}
        </div>

        {/* Âge */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:5}}>ÂGE (facultatif)</label>
        <input type="number" value={age} onChange={e=>setAge(e.target.value)} placeholder="Ex : 25"
          style={{width:"100%",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"10px 14px",outline:"none",boxSizing:"border-box",marginBottom:12}}/>

        {/* Poids + Taille */}
        <div style={{display:"flex",gap:12,marginBottom:16}}>
          <div style={{flex:1}}>
            <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:5}}>POIDS (kg)</label>
            <input type="number" value={weight} onChange={e=>setWeight(e.target.value)} placeholder="Ex : 75"
              style={{width:"100%",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"10px 14px",outline:"none",boxSizing:"border-box"}}/>
          </div>
          <div style={{flex:1}}>
            <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:5}}>TAILLE (cm)</label>
            <input type="number" value={height} onChange={e=>setHeight(e.target.value)} placeholder="Ex : 178"
              style={{width:"100%",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"10px 14px",outline:"none",boxSizing:"border-box"}}/>
          </div>
        </div>
      </div>
      <div style={{padding:"12px 24px calc(env(safe-area-inset-bottom) + 28px)",flexShrink:0}}>
        {dots}
        <button onClick={()=>{if(canNext1)setStep(2);}} style={{width:"100%",padding:"15px",background:canNext1?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:14,color:canNext1?"white":C.muted,fontWeight:800,fontSize:15,cursor:canNext1?"pointer":"default",boxShadow:canNext1?`0 6px 20px ${C.glow}`:"none",transition:"all 0.2s"}}>
          Suivant →
        </button>
      </div>
    </div>
  );

  // ── STEP 2 : Lieu + Équipement ───────────────────────────────────────────
  const HOME_EQUIPMENT=[
    {id:"halteres",label:"Haltères"},
    {id:"barre",label:"Barre"},
    {id:"kettlebells",label:"Kettlebells"},
    {id:"banc",label:"Banc"},
    {id:"barre_traction",label:"Traction"},
    {id:"elastiques",label:"Élastiques"},
  ];

  if(step===2) return(
    <div style={{background:C.bg,height:"100vh",display:"flex",flexDirection:"column",padding:0,boxSizing:"border-box"}}>
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 24px 0",flexShrink:0}}>
        <button onClick={()=>setStep(1)} style={{background:"none",border:"none",color:C.muted,fontSize:22,cursor:"pointer",alignSelf:"flex-start",padding:0,marginBottom:8}}>←</button>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"0 24px"}}>
        <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 3px"}}>ÉTAPE 2 / 4</p>
        <h2 style={{color:C.text,fontSize:20,fontWeight:900,margin:"0 0 3px"}}>Où t'entraînes-tu ?</h2>
        <p style={{color:C.muted,fontSize:12,margin:"0 0 16px"}}>On adaptera les exercices à ton équipement.</p>

        {/* Salle ou Maison */}
        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
          <button onClick={()=>setLocation("salle")}
            style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",borderRadius:14,border:`2px solid ${location==="salle"?C.accent:C.border}`,background:location==="salle"?`${C.accent}10`:C.faint,cursor:"pointer",transition:"all 0.15s"}}>
            <div style={{flex:1,textAlign:"left"}}>
              <p style={{color:location==="salle"?C.accent:C.text,fontWeight:800,fontSize:14,margin:"0 0 1px"}}>Salle de sport</p>
              <p style={{color:C.muted,fontSize:11,margin:0}}>Accès complet aux machines</p>
            </div>
            {location==="salle"&&<div style={{width:20,height:20,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <span style={{color:"white",fontSize:11,fontWeight:900}}>✓</span>
            </div>}
          </button>
          <button onClick={()=>setLocation("maison")}
            style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",borderRadius:14,border:`2px solid ${location==="maison"?C.accent:C.border}`,background:location==="maison"?`${C.accent}10`:C.faint,cursor:"pointer",transition:"all 0.15s"}}>
            <div style={{flex:1,textAlign:"left"}}>
              <p style={{color:location==="maison"?C.accent:C.text,fontWeight:800,fontSize:14,margin:"0 0 1px"}}>À la maison</p>
              <p style={{color:C.muted,fontSize:11,margin:0}}>Matériel spécifique en option</p>
            </div>
            {location==="maison"&&<div style={{width:20,height:20,borderRadius:"50%",background:C.accent,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <span style={{color:"white",fontSize:11,fontWeight:900}}>✓</span>
            </div>}
          </button>
        </div>

        {/* Équipement maison — 3 colonnes 2 lignes */}
        {location==="maison"&&(
          <div style={{marginBottom:16}}>
            <p style={{color:C.text,fontSize:13,fontWeight:700,margin:"0 0 10px"}}>Quel équipement as-tu ?</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
              {HOME_EQUIPMENT.map(eq=>{
                const selected=homeEquip.includes(eq.id);
                return(
                  <button key={eq.id} onClick={()=>toggleEquip(eq.id)}
                    style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6,padding:"10px 6px",borderRadius:12,border:`2px solid ${selected?C.accent:C.border}`,background:selected?`${C.accent}12`:C.card,cursor:"pointer",transition:"all 0.2s",textAlign:"center",minHeight:56}}>
                    <span style={{color:selected?C.accent:C.text,fontSize:11,fontWeight:700,lineHeight:1.2}}>{eq.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <div style={{padding:"12px 24px calc(env(safe-area-inset-bottom) + 28px)",flexShrink:0}}>
        {dots}
        <button onClick={()=>{if(canNext2)setStep(3);}} style={{width:"100%",padding:"15px",background:canNext2?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:14,color:canNext2?"white":C.muted,fontWeight:800,fontSize:15,cursor:canNext2?"pointer":"default",boxShadow:canNext2?`0 6px 20px ${C.glow}`:"none",transition:"all 0.2s"}}>
          Suivant →
        </button>
      </div>
    </div>
  );

  // ── STEP 3 : Durée + jours ───────────────────────────────────────────────
  const DURATIONS=[
    {v:30,label:"30m"},{v:45,label:"45m"},{v:60,label:"1h"},{v:75,label:"1h15"},{v:90,label:"1h30"},
  ];
  const DAYS=[{v:3,label:"3 jours"},{v:4,label:"4 jours"},{v:5,label:"5 jours"}];

  if(step===3) return(
    <div style={{background:C.bg,height:"100vh",display:"flex",flexDirection:"column",padding:0,boxSizing:"border-box"}}>
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 24px 0",flexShrink:0}}>
        <button onClick={()=>setStep(2)} style={{background:"none",border:"none",color:C.muted,fontSize:22,cursor:"pointer",alignSelf:"flex-start",padding:0,marginBottom:8}}>←</button>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"0 24px"}}>
        <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 3px"}}>ÉTAPE 3 / 4</p>
        <h2 style={{color:C.text,fontSize:20,fontWeight:900,margin:"0 0 3px"}}>Ton programme idéal</h2>
        <p style={{color:C.muted,fontSize:12,margin:"0 0 16px"}}>On va générer tes séances selon ton lieu, ton sexe, ton matériel et ta disponibilité.</p>

        {/* Durée par séance */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:6}}>DURÉE PAR SÉANCE</label>
        <div style={{display:"flex",gap:6,marginBottom:20}}>
          {DURATIONS.map(d=>(
            <button key={d.v} onClick={()=>setDuration(d.v)}
              style={{flex:1,padding:"11px 2px",borderRadius:10,border:`1px solid ${duration===d.v?C.accent:C.border}`,background:duration===d.v?`${C.accent}15`:C.faint,cursor:"pointer",transition:"all 0.15s",textAlign:"center"}}>
              <p style={{color:duration===d.v?C.accent:C.text,fontWeight:900,fontSize:13,margin:0}}>{d.label}</p>
            </button>
          ))}
        </div>

        {/* Jours */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:6}}>JOURS PAR SEMAINE</label>
        <div style={{display:"flex",gap:6,marginBottom:20}}>
          {DAYS.map(d=>(
            <button key={d.v} onClick={()=>setDays(d.v)}
              style={{flex:1,padding:"10px 6px",borderRadius:10,border:`1px solid ${days===d.v?C.accent:C.border}`,background:days===d.v?`${C.accent}15`:C.faint,cursor:"pointer",transition:"all 0.15s",textAlign:"center"}}>
              <p style={{color:days===d.v?C.accent:C.text,fontWeight:900,fontSize:16,margin:"0 0 1px"}}>{d.v}</p>
              <p style={{color:C.muted,fontSize:8,margin:0}}>{d.v===3?"Flexible":d.v===4?"Régulier":"Intensif"}</p>
            </button>
          ))}
        </div>

        {/* Objectif fitness */}
        <label style={{color:C.muted,fontSize:10,letterSpacing:2,display:"block",marginBottom:6}}>OBJECTIF FITNESS <span style={{color:C.accent,fontSize:9}}>(optionnel — utilisé par Beaggy IA)</span></label>
        <div style={{display:"flex",gap:6,marginBottom:20}}>
          {[{v:"force",label:"Force",sub:"3-6 reps"},{v:"hypertrophie",label:"Hypertrophie",sub:"8-12 reps"},{v:"endurance",label:"Endurance",sub:"15-20 reps"}].map(o=>(
            <button key={o.v} onClick={()=>setFitnessGoal(p=>p===o.v?null:o.v)}
              style={{flex:1,padding:"10px 4px",borderRadius:10,border:`1px solid ${fitnessGoal===o.v?C.accent:C.border}`,background:fitnessGoal===o.v?`${C.accent}15`:C.faint,cursor:"pointer",transition:"all 0.15s",textAlign:"center"}}>
              <p style={{color:fitnessGoal===o.v?C.accent:C.text,fontWeight:900,fontSize:12,margin:"0 0 1px"}}>{o.label}</p>
              <p style={{color:C.muted,fontSize:8,margin:0}}>{o.sub}</p>
            </button>
          ))}
        </div>
      </div>
      <div style={{padding:"12px 24px calc(env(safe-area-inset-bottom) + 28px)",flexShrink:0}}>
        {dots}
        <button onClick={()=>{if(canNext3)setStep(4);}} style={{width:"100%",padding:"14px",background:canNext3?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:14,color:canNext3?"white":C.muted,fontWeight:800,fontSize:15,cursor:canNext3?"pointer":"default",boxShadow:canNext3?`0 6px 20px ${C.glow}`:"none",transition:"all 0.2s"}}>
          Suivant
        </button>
      </div>
    </div>
  );

  // ── STEP 4 : Tutorial optionnel ──────────────────────────────────────────
  return(
    <div style={{background:C.bg,height:"100vh",display:"flex",flexDirection:"column",padding:0,boxSizing:"border-box"}}>
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 24px 0",flexShrink:0}}>
        <button onClick={()=>setStep(3)} style={{alignSelf:"flex-start",background:"none",border:"none",color:C.muted,fontSize:22,cursor:"pointer",padding:0,marginBottom:8}}>←</button>
      </div>
      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",padding:"0 24px"}}>
        <h1 style={{color:C.text,fontSize:26,fontWeight:900,margin:"0 0 14px",lineHeight:1.2}}>Tout est prêt !</h1>
        <p style={{color:C.muted,fontSize:15,lineHeight:1.65,margin:"0 0 12px",maxWidth:320}}>Tes séances sont générées selon ton profil. Tu peux aussi créer tes propres programmes depuis l'accueil.</p>
        <p style={{color:C.muted,fontSize:13,lineHeight:1.6,maxWidth:300}}>Veux-tu un rapide tutoriel pour découvrir l'app ?</p>
      </div>
      <div style={{padding:"12px 24px calc(env(safe-area-inset-bottom) + 28px)",flexShrink:0}}>
        {dots}
        <div style={{width:"100%",display:"flex",flexDirection:"column",gap:12}}>
          <button onClick={()=>handleFinish(true)} style={{width:"100%",padding:"16px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:16,cursor:"pointer",boxShadow:`0 6px 24px ${C.glow}`}}>
            Oui, voir le tutoriel
          </button>
          <button onClick={()=>handleFinish(false)} style={{width:"100%",padding:"14px",background:"transparent",border:`2px solid ${C.border}`,borderRadius:14,color:C.text,fontWeight:700,fontSize:14,cursor:"pointer"}}>
            Non, commencer directement
          </button>
        </div>
      </div>
    </div>
  );
}


// ─── SESSION SUMMARY PAGE ─────────────────────────────────────────────────────


function loadStorage() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

function saveStorage(data) {
  try { localStorage.setItem(LS_KEY, JSON.stringify({...data, _savedAt: Date.now()})); } catch {}
}

// ─── APP ROOT ─────────────────────────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════════════
// FONCTION D'ADAPTATION DES EXERCICES POUR ÉQUIPEMENT MAISON
// ═══════════════════════════════════════════════════════════════════════════

export default function App() {
  const saved = loadStorage();

  const [themeId,setThemeId]=useState(saved.themeId??"yellow");
  // darkMode : suit les préférences système si jamais modifié manuellement
  const getSystemDark = ()=> typeof window!=="undefined" && !!window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  const [darkManual,setDarkManual]=useState(saved.darkMode!=null ? saved.darkMode : true); // true = dark par défaut
  const [systemDark,setSystemDark]=useState(getSystemDark);
  const darkMode = darkManual!=null ? darkManual : systemDark;
  const C=makeC(THEMES.find(t=>t.id===themeId)||THEMES[0], darkMode);

  // Synchronisation automatique avec le thème système
  useEffect(()=>{
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    if(!mq) return;
    const handler = (e)=>{ setSystemDark(e.matches); };
    mq.addEventListener("change", handler);
    return ()=>mq.removeEventListener("change", handler);
  },[]);


  // Restaurer la session/tabata en cours si elle existait
  const _savedSession=(()=>{try{const r=localStorage.getItem(LS_SESSION_KEY);return r?JSON.parse(r):null;}catch{return null;}})();
  const _savedTabata=(()=>{try{const r=localStorage.getItem(LS_TABATA_KEY);return r?JSON.parse(r):null;}catch{return null;}})();

  const [programs,setPrograms]=useState(saved.programs??[]);
  const [sessions,setSessions]=useState(saved.sessions??[]);
  const [tabatas,setTabatas]=useState(saved.tabatas??[]);

  // Trouver le programme/tabata actif correspondant à la session sauvegardée
  const _restoredProg=_savedSession?((saved.programs??[]).find(p=>p.id===_savedSession.programId)||null):null;
  const _restoredTab=_savedTabata?((saved.tabatas??[]).find(t=>t.id===_savedTabata.programId)||null):null;

  const [activeProgram,setActive]=useState(_restoredProg);
  const [activeTabata,setActiveTab]=useState(_restoredTab);
  const [page,setPage]=useState(_restoredTab?"runTabata":"home");
  const [showResumeModal,setShowResumeModal]=useState(!!_restoredProg);
  // Onboarding : s'affiche si jamais complété ET profil null
  const [showOnboarding,setShowOnboarding]=useState(!saved.onboardingDone&&!saved.profile&&!_restoredProg&&!_restoredTab);
  const [showTutorial,setShowTutorial]=useState(false);

  // Refs tutoriel — navbar
  const navHomeRef=useRef(null);
  const navTabataRef=useRef(null);
  const navSuiviRef=useRef(null);
  const navProfileRef=useRef(null);
  // Refs tutoriel — éléments dans les pages (remontés via props)
  const startSessionRef=useRef(null);
  const createProgRef=useRef(null);
  const tabGeneratedRef=useRef(null);
  const tabCustomRef=useRef(null);
  const setActiveRef=useRef(null);
  const generateTabataRef=useRef(null);
  const createTabataRef=useRef(null);
  const tutorialRefs={
    navHome:navHomeRef, navTabata:navTabataRef,
    navSuivi:navSuiviRef, navProfile:navProfileRef,
    startSession:startSessionRef,
    createProg:createProgRef, tabGenerated:tabGeneratedRef, tabCustom:tabCustomRef, setActive:setActiveRef,
    generateTabata:generateTabataRef, createTabata:createTabataRef,
  };
  const [editProgram,setEditProg]=useState(null);
  const [editTabata,setEditTabata]=useState(null);
  const [voice,setVoice]=useState(saved.voice??false);
  const [profile,setProfile]=useState(saved.profile??null);
  const [measurements,setMeasurements]=useState(saved.measurements??[]);
  const [prs,setPRs]=useState(saved.prs??{});
  // exerciseWeights : { [exerciseName]: maxWeight } — persiste les poids max validés par exercice
  const [exerciseWeights,setExerciseWeights]=useState(saved.exerciseWeights??{});
  const [selectedGroupName,setSelectedGroupName]=useState(saved.selectedGroupName??null);
  const [customGroupNames,setCustomGroupNames]=useState(saved.customGroupNames??[]);
  const [defaultProgramId,setDefaultProgramId]=useState(saved.defaultProgramId??null);
  // XP total — initialisé depuis le storage, ou recalculé depuis l'historique si absent
  const [totalXP, setTotalXP] = useState(() => {
    if (saved.totalXP != null) return saved.totalXP;
    return recalcTotalXP(saved.sessions ?? [], saved.prs ?? {}, saved.profile?.days ?? 3);
  });
  const onSavePR=(name,pr)=>{setPRs(p=>{
    // Si history est fourni explicitement (ex: suppression d'une entrée), l'utiliser tel quel
    if(pr.history!==undefined){
      return {...p,[name]:{weight:pr.weight,date:pr.date,history:pr.history}};
    }
    const existing=p[name]||{};
    const history=[...(existing.history||[])];
    // Ajouter l'ancienne valeur à l'historique si elle existe
    if(existing.weight&&existing.date){
      history.push({weight:existing.weight,date:existing.date});
    }
    return {...p,[name]:{weight:pr.weight,date:pr.date,history}};
  });
  // +2 XP par PR enregistré (nouveau PR uniquement, pas mise à jour historique)
  if(pr.history===undefined) setTotalXP(x => x + calcPRXP());
  };

  // Sauvegarde automatique à chaque changement d'état persistant
  useEffect(()=>{
    saveStorage({ themeId, darkMode:darkManual, programs, sessions, tabatas, voice, profile, measurements, prs, exerciseWeights, selectedGroupName, customGroupNames, onboardingDone:!showOnboarding, defaultProgramId, totalXP });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeId, darkManual, programs, sessions, tabatas, voice, profile, measurements, prs, exerciseWeights, selectedGroupName, customGroupNames, showOnboarding, defaultProgramId]);

  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [pendingProfileRegen, setPendingProfileRegen] = useState(null); // {profile, customPrograms, generated}
  const [homeProgTab, setHomeProgTab] = useState("generated"); // persiste l'onglet actif entre navigations
  const [homeSwipePage, setHomeSwipePage] = useState(0); // 0=séance, 1=programmes
  const [showGeneratePage, setShowGeneratePage] = useState(false);
  const [suiviResetKey, setSuiviResetKey] = useState(0);

  // ── AUTH ──────────────────────────────────────────────────────────────────
  const [user, setUser] = useState(undefined); // undefined = chargement, null = non connecté, objet = connecté
  const [guestMode, setGuestMode] = useState(()=>{
    try{return localStorage.getItem('bf-guest')==='1';}catch{return false;}
  });
  const [cloudSyncing, setCloudSyncing] = useState(false);
  const [cloudLoaded, setCloudLoaded] = useState(false); // true après chargement cloud initial
  useEffect(()=>{
    const unsub = onAuthStateChanged(fbAuth, async (u) => {
      setUser(u || null);
      if(u) await loadFromCloud(u.uid);
    });
    return unsub;
  },[]);

  // Charger depuis Firestore avec fusion intelligente
  const loadFromCloud = async (uid) => {
    try {
      const snap = await getDoc(doc(fbDb, "users", uid));
      if(snap.exists()) {
        const cloud = snap.data();
        const localRaw = (()=>{try{const r=localStorage.getItem(LS_KEY);return r?JSON.parse(r):{};}catch{return {};}})();
        const localTs = localRaw._savedAt || 0;
        const cloudTs = cloud._savedAt || 0;

        // Fusion : on prend le maximum de chaque tableau, le plus récent pour les objets
        const mergeArr = (a, b, key, localWins=false) => {
          if(!a?.length && !b?.length) return [];
          if(!a?.length) return b||[];
          if(!b?.length) return a||[];
          const map = new Map();
          // Pour les programmes : déduplication aussi par groupName+name (évite doublons local/cloud)
          const progKey = (item) => {
            if(item.groupName && item.name) return `grp:${item.groupName}|${item.name}`;
            return item.id||item.date||JSON.stringify(item);
          };
          if(localWins) {
            // Local wins : on part du local, on enrichit avec les entrées cloud absentes du local
            a.forEach(item=>map.set(progKey(item), item));
            const localKeys = new Set(a.map(progKey));
            // N'ajouter depuis le cloud que les entrées que le local n'a jamais eues
            // Si une clé est dans le cloud mais pas dans le local → supprimée localement → on l'ignore
            // Pour éviter ce cas, on compare les tailles : si local < cloud, c'est une suppression locale
            // Stratégie : on n'ajoute RIEN du cloud qui n'est pas déjà dans local
            // (le local est source de vérité pour les suppressions)
          } else {
            // Priorité au cloud (b) sur local (a) : on insère a en premier, b écrase
            [...a,...b].forEach(item=>{
              const k = progKey(item);
              map.set(k, item); // b écrase a si même clé → version cloud gagne
            });
          }
          return Array.from(map.values());
        };
        const mergeObj = (a, b) => ({...(a||{}), ...(b||{})});

        // Pour chaque donnée : on fusionne en gardant le max
        const merged = {
          profile:         cloud.profile || localRaw.profile,
          programs:        (()=>{
            const localCustom = (localRaw.programs||[]).filter(p=>p.isCustom);
            const cloudCustom = (cloud.programs||[]).filter(p=>p.isCustom);
            const cloudGenerated = (cloud.programs||[]).filter(p=>!p.isCustom);
            const localGenerated = (localRaw.programs||[]).filter(p=>!p.isCustom);
            // Générés : le cloud écrase toujours le local (un seul programme généré possible)
            const generated = cloudGenerated.length ? cloudGenerated : localGenerated;
            // Perso : merge normal
            const customMerged = mergeArr(localCustom, cloudCustom, 'id');
            return [...generated, ...customMerged];
          })(),
          sessions:        mergeArr(localRaw.sessions, cloud.sessions, 'id'),
          tabatas:         mergeArr(localRaw.tabatas, cloud.tabatas, 'id'),
          measurements:    mergeArr(localRaw.measurements, cloud.measurements, 'date', true),
          prs:             mergeObj(localRaw.prs, cloud.prs),
          exerciseWeights: mergeObj(localRaw.exerciseWeights, cloud.exerciseWeights),
          selectedGroupName: cloud.selectedGroupName ?? localRaw.selectedGroupName,
          customGroupNames:  mergeArr(localRaw.customGroupNames?.map(n=>({id:n,n})), cloud.customGroupNames?.map(n=>({id:n,n})),'id').map(x=>x.n),
          themeId:         cloud.themeId || localRaw.themeId,
          darkMode:        cloud.darkMode ?? localRaw.darkMode,
          voice:           cloud.voice ?? localRaw.voice,
          onboardingDone:  cloud.onboardingDone || localRaw.onboardingDone,
          defaultProgramId: cloud.defaultProgramId ?? localRaw.defaultProgramId,
          totalXP:         cloud.totalXP ?? localRaw.totalXP ?? 0,
          mascotToday:     (()=>{
            const todayKey = (()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;})();
            const cm = cloud.mascotToday;
            // Ne restaurer depuis Firebase que si le message est d'aujourd'hui
            if(cm && cm.date === todayKey) return cm;
            // Sinon garder le local s'il est d'aujourd'hui
            const lm = localRaw.mascotToday;
            if(lm && lm.date === todayKey) return lm;
            return null;
          })(),
        };

        // Appliquer le résultat fusionné
        if(merged.profile)          setProfile(merged.profile);
        if(merged.programs?.length) setPrograms(merged.programs);
        if(merged.sessions)         setSessions(merged.sessions);
        if(merged.tabatas)          setTabatas(merged.tabatas);
        if(merged.measurements)     setMeasurements(merged.measurements);
        if(merged.prs)              setPRs(merged.prs);
        if(merged.exerciseWeights)  setExerciseWeights(merged.exerciseWeights);
        if(merged.selectedGroupName !== undefined) setSelectedGroupName(merged.selectedGroupName);
        if(merged.customGroupNames?.length) setCustomGroupNames(merged.customGroupNames);
        if(merged.themeId)          setThemeId(merged.themeId);
        if(merged.onboardingDone)   setShowOnboarding(false);
        if(merged.defaultProgramId !== undefined) setDefaultProgramId(merged.defaultProgramId);
        if(merged.totalXP != null) setTotalXP(merged.totalXP);
        if(merged.mascotToday) {
          const todayKey = (()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;})();
          if(merged.mascotToday.date === todayKey) {
            try { localStorage.setItem('bearforge_mascot_today', JSON.stringify(merged.mascotToday)); } catch {}
          }
        }

        // Sauvegarder la fusion en local uniquement
        // Le useEffect de sync cloud s'occupera de pousser vers Firestore après mise à jour des states
        saveStorage(merged);
      }
      setCloudLoaded(true);
    } catch(e) {
      console.error("[Calestan] loadFromCloud error:", e?.message||e);
      setCloudLoaded(true);
    }
  };

  // Sauvegarder dans Firestore (debounced via useEffect)
  const pendingSyncRef = useRef(null);

  const saveToCloud = useCallback(async (uid, data) => {
    if(!uid) return;
    if(!navigator.onLine){
      // Hors ligne : stocker en attente localement
      try{ localStorage.setItem("bearforge_pending_sync", JSON.stringify({uid, data, ts: Date.now()})); }catch{}
      return;
    }
    try {
      setCloudSyncing(true);
      await setDoc(doc(fbDb, "users", uid), data, { merge: false });
      // Succès → supprimer la file d'attente si elle existait
      try{ localStorage.removeItem("bearforge_pending_sync"); }catch{}
    } catch(e) {
      // Erreur réseau → stocker pour retry
      console.error("[Calestan] Cloud sync error:", e?.message||e);
      try{ localStorage.setItem("bearforge_pending_sync", JSON.stringify({uid, data, ts: Date.now()})); }catch{}
    } finally {
      setCloudSyncing(false);
    }
  }, []);

  // Reprendre la sync en attente au retour du réseau
  useEffect(()=>{
    const handleOnline = async () => {
      try{
        const raw = localStorage.getItem("bearforge_pending_sync");
        if(!raw) return;
        const {uid, data} = JSON.parse(raw);
        if(!uid || !data) return;
        setCloudSyncing(true);
        await setDoc(doc(fbDb, "users", uid), data, { merge: false });
        localStorage.removeItem("bearforge_pending_sync");
      } catch{}
      finally{ setCloudSyncing(false); }
    };
    window.addEventListener("online", handleOnline);
    return ()=>window.removeEventListener("online", handleOnline);
  }, []);

  // Sync cloud automatique à chaque changement (si connecté)
  // On attend que le chargement initial soit terminé avant de sauvegarder
  useEffect(()=>{
    if(!user || !cloudLoaded) return;
    const t = setTimeout(()=>{
      saveToCloud(user.uid, {
        themeId, darkMode: darkManual, programs, sessions, tabatas,
        voice, profile, measurements, prs, exerciseWeights,
        selectedGroupName, customGroupNames, onboardingDone: !showOnboarding, defaultProgramId,
        totalXP,
        _savedAt: Date.now()
      });
    }, 1500); // debounce 1.5s
    return ()=>clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, cloudLoaded, themeId, darkManual, programs, sessions, tabatas, voice, profile, measurements, prs, exerciseWeights, selectedGroupName, customGroupNames, showOnboarding, defaultProgramId]);

  const handleSignOut = async () => {
    // Push forcé avant déconnexion pour ne pas perdre les données non encore synchronisées
    if(user) {
      try {
        const mascotToday = (()=>{try{return JSON.parse(localStorage.getItem('bearforge_mascot_today')||'null');}catch{return null;}})();
        await saveToCloud(user.uid, {
          themeId, darkMode: darkManual, programs, sessions, tabatas,
          voice, profile, measurements, prs, exerciseWeights,
          selectedGroupName, customGroupNames, onboardingDone: !showOnboarding, defaultProgramId,
          totalXP, mascotToday,
          _savedAt: Date.now()
        });
      } catch {}
    }
    await signOut(fbAuth);
    try { localStorage.removeItem(LS_KEY); } catch {}
    try { localStorage.removeItem('bf-guest'); } catch {}
    try { localStorage.removeItem('bearforge_mascot_today'); } catch {}
    setUser(null);
    setGuestMode(false);
    setPrograms([]);
    setSessions([]);
    setTabatas([]);
    setVoice(false);
    setProfile(null);
    setMeasurements([]);
    setPRs({});
    setExerciseWeights({});
    setTotalXP(0);
    setSelectedGroupName(null);
    setCustomGroupNames([]);
    setThemeId("yellow");
    setDarkManual(null);
    setCloudLoaded(false);
    setShowOnboarding(true);
    setPage("home");
  };

  // Bannière notation — 1ère fois à 20 séances, 2e fois à 70 si refusée
  const [showRatingBanner, setShowRatingBanner] = useState(false);
  useEffect(()=>{
    const status = localStorage.getItem('bf_rating_status'); // 'done' | 'dismissed_once' | null
    const totalSessions = sessions.length;

    if(status === 'done') return; // Déjà noté ou définitivement fermé

    if(!showOnboarding){
      // 1ère tentative à 20 séances
      if(!status && totalSessions >= 20){
        const t = setTimeout(()=>setShowRatingBanner(true), 2000);
        return ()=>clearTimeout(t);
      }
      // 2e tentative à 70 séances (si dismissed_once)
      if(status === 'dismissed_once' && totalSessions >= 70){
        const t = setTimeout(()=>setShowRatingBanner(true), 2000);
        return ()=>clearTimeout(t);
      }
    }
  },[sessions.length, showOnboarding]);

  const dismissRating = () => {
    const status = localStorage.getItem('bf_rating_status');
    if(!status){
      // 1er refus → marquer dismissed_once
      localStorage.setItem('bf_rating_status','dismissed_once');
    } else {
      // 2e refus → ne plus jamais afficher
      localStorage.setItem('bf_rating_status','done');
    }
    setShowRatingBanner(false);
  };

  const acceptRating = () => {
    localStorage.setItem('bf_rating_status','done');
    setShowRatingBanner(false);
    window.open('https://calestan.fr','_blank');
  };

  const handleReset = () => setShowResetConfirm(true);


  const confirmReset = () => {
    try { localStorage.removeItem(LS_KEY); } catch {}
    setPrograms([]);
    setSessions([]);
    setTabatas([]);
    setVoice(false);
    setProfile(null);
    setMeasurements([]);
    setPRs({});
    setExerciseWeights({});
    setSelectedGroupName(null);
    setCustomGroupNames([]);
    setThemeId("yellow");
    setDarkManual(null);
    setShowResetConfirm(false);
    setPage("home");
  };


  const handleOnboardingComplete=(profile,wantsTutorial)=>{
    setProfile(profile);
    
    // Générer programmes adaptés
    const generated = generateAdaptedPrograms(
      profile.duration || 60,
      profile.days,
      profile.gender,
      profile.equipment,
      profile.homeEquip,
      exerciseWeights
    );
    
    
    if(generated && generated.length > 0) {
      setPrograms(generated.map(p=>({...p,id:Date.now()+Math.random()})));
      // Mettre le premier groupe généré comme programme actif par défaut
      if(generated[0]?.groupName) setDefaultProgramId(generated[0].groupName);
    } else {
      console.error('No programs generated!');
    }
    
    setShowOnboarding(false);
    if(wantsTutorial){
      setShowTutorial(true);
    }
  };
  const handleOnboardingSkip=()=>setShowOnboarding(false);

  // Applique les suggestions IA (poids/reps/séries) sur le programme lié à la session
  const handleApplySuggestions=(sessionId,adaptations)=>{
    if(!adaptations||!adaptations.length) return;
    const session=sessions.find(s=>s.id===sessionId);
    if(!session?.programId) return;
    setPrograms(prev=>prev.map(prog=>{
      if(prog.id!==session.programId) return prog;
      const updatedExercises=(prog.exercises||[]).map(ex=>{
        const adap=adaptations.find(a=>a.exercise===ex.name);
        if(!adap) return ex;
        // Mettre à jour plannedSets (lu par SessionPage) ET sets
        const newSets=Array.from({length:adap.sets},(_,i)=>({...(ex.sets?.[i]||{}),reps:adap.reps,weight:adap.weight}));
        const newPlanned=Array.from({length:adap.sets},(_,i)=>({...(ex.plannedSets?.[i]||{}),reps:adap.reps,weight:adap.weight,aiSuggested:true}));
        return {...ex,sets:newSets,plannedSets:newPlanned};
      });
      return {...prog,exercises:updatedExercises};
    }));
    // exerciseWeights intentionnellement non modifié : les poids suggérés passent par plannedSets
    setSessions(prev=>prev.map(s=>s.id===sessionId?{...s,aiApplied:true}:s));
  };

  // Calcul du streak en semaines validées
  // Une semaine est validée si nb séances >= objectif (profile.days) ou >= 3 par défaut
  const localDateKey=(date)=>{const d=new Date(date);return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;};
  // getWeekKey : retourne la clé du lundi de la semaine en heure LOCALE (évite le bug UTC)
  const getWeekKey=(date)=>{
    const d=new Date(date);
    const day=d.getDay()===0?6:d.getDay()-1; // lundi=0
    d.setDate(d.getDate()-day);
    return localDateKey(d); // heure locale, pas UTC
  };
  const calcStreak=(sessions)=>{
    if(!sessions.length)return 0;
    const target=(()=>{
      if(!programs||!defaultProgramId) return profile?.days||3;
      const byGroup=programs.filter(p=>p.groupName===defaultProgramId);
      if(byGroup.length>0) return byGroup.length;
      const prog=programs.find(p=>p.id===defaultProgramId);
      if(!prog) return profile?.days||3;
      if(prog.days) return prog.days;
      const grp=prog.groupName||'';
      const match=grp.match(/(\d+)j$/);
      if(match) return parseInt(match[1]);
      if(grp) return programs.filter(p=>p.groupName===grp).length||1;
      return profile?.days||3;
    })();
    // Compter SÉANCES muscu par semaine
    const weekMap={};
    sessions.filter(s=>s.type!=="tabata").forEach(s=>{
      if(!s.date)return;
      const wk=getWeekKey(s.date);
      weekMap[wk]=(weekMap[wk]||0)+1;
    });
    // Remonter les semaines consécutives validées — tout en heure locale
    let streak=0;
    const d=new Date();
    const day=d.getDay()===0?6:d.getDay()-1;
    d.setDate(d.getDate()-day); // lundi de cette semaine
    // Si semaine en cours pas encore validée, on commence à la semaine d'avant
    if((weekMap[localDateKey(d)]||0)<target){
      d.setDate(d.getDate()-7);
    }
    while(true){
      const k=localDateKey(d);
      if((weekMap[k]||0)>=target){streak++;d.setDate(d.getDate()-7);}
      else break;
    }
    return streak;
  };
  const streak=calcStreak(sessions); // toutes les séances (muscu + tabata) comptent pour le streak

  // Page résumé de fin de séance
  const [summarySession,setSummarySession]=useState(null);

  const shareCardRef=useRef(null);
  const handleShareCapture=async()=>{
    if(!shareCardRef.current)return;
    try{
      const canvas=await html2canvas(shareCardRef.current,{scale:2,useCORS:true,backgroundColor:null});
      const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png',1.0));
      const file=new File([blob],'calestan-seance.png',{type:'image/png'});
      if(navigator.share&&navigator.canShare&&navigator.canShare({files:[file]})){
        await navigator.share({files:[file],title:'Ma séance Calestan'});
      }else{
        const url=URL.createObjectURL(blob);
        const a=document.createElement('a');a.href=url;
        a.download=`calestan-${Date.now()}.png`;a.click();
        setTimeout(()=>URL.revokeObjectURL(url),1000);
      }
    }catch(e){console.error('Share error:',e);}
  };

  const [newMedalKey,setNewMedalKey]=useState(null);

  const nav=[
    {id:"home",    label:"Muscu",  svg:(active)=>(
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?C.accent:"#555"} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <line x1="7" y1="12" x2="17" y2="12" strokeWidth="1.6"/>
        <line x1="7" y1="8" x2="7" y2="16" strokeWidth="3.5"/>
        <line x1="17" y1="8" x2="17" y2="16" strokeWidth="3.5"/>
        <line x1="4" y1="10" x2="4" y2="14" strokeWidth="2.5"/>
        <line x1="20" y1="10" x2="20" y2="14" strokeWidth="2.5"/>
      </svg>
    )},
    {id:"tabata",  label:"Tabata", svg:(active)=>(
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?C.accent:"#555"} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="13" r="7"/><line x1="12" y1="10" x2="12" y2="13"/><line x1="12" y1="13" x2="15" y2="15"/><line x1="9" y1="2" x2="15" y2="2"/><line x1="12" y1="2" x2="12" y2="6"/>
      </svg>
    )},
    {id:"suivi",   label:"Suivi",  svg:(active)=>(
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?C.accent:"#555"} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3,17 8,12 13,14 21,7"/><line x1="3" y1="20" x2="21" y2="20"/>
      </svg>
    )},
    {id:"profile", label:"Profil", svg:(active)=>(
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?C.accent:"#555"} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
      </svg>
    )},
  ];

  const navBg=darkMode?"rgba(8,8,8,0.97)":"rgba(245,245,240,0.98)";

  // Auth loading state
  if(user === undefined) {
    return(
      <div style={{background:C.bg,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <img src={LOGO_LIGHT_DATA} alt="Calestan" style={{height:80,objectFit:"contain",opacity:0.7}}/>
      </div>
    );
  }

  // Not logged in → show login page
  if(user === null && !guestMode) {
    return <LoginPage onLogin={()=>{}} onGuest={()=>{
      try{localStorage.setItem('bf-guest','1');}catch{}
      setGuestMode(true);
    }} C={C}/>;
  }

  return(
    <div style={{background:C.bg,minHeight:"100vh",maxWidth:480,margin:"0 auto",fontFamily:"'DM Sans',-apple-system,BlinkMacSystemFont,sans-serif",position:"relative",overflowX:"hidden",color:C.text}}>
      {/* Cloud sync indicator */}
      {cloudSyncing&&<div style={{position:"fixed",top:8,right:12,zIndex:999,background:`${C.accent}20`,border:`1px solid ${C.accent}40`,borderRadius:20,padding:"3px 10px",display:"flex",alignItems:"center",gap:5}}>
        <div style={{width:6,height:6,borderRadius:"50%",background:C.accent,animation:"pulse 1s infinite"}}/>
        <span style={{color:C.accent,fontSize:10,fontWeight:700}}>Sync</span>
      </div>}
      {showOnboarding&&<OnboardingPage onComplete={handleOnboardingComplete} onSkip={handleOnboardingSkip} C={C}/>}
      {showTutorial&&<TutorialPage refs={tutorialRefs} onComplete={()=>setShowTutorial(false)} onSetPage={setPage} onSwipeToPrograms={()=>setHomeSwipePage(1)} onSwitchProgTab={setHomeProgTab} C={C}/>}
      {summarySession&&<SessionSummaryPage session={summarySession} streak={calcStreak(sessions)} userWeight={profile?.weight||null} xpGained={summarySession?.xpGained||0} onShare={handleShareCapture} onLaunchFinisher={t=>{setSummarySession(null);setActive(null);setActiveTab(t);setPage("runTabata");}} fitnessGoal={profile?.fitnessGoal||null} freeAnalysesUsed={profile?.freeAnalysesUsed||0} lastFreeAnalysisDate={profile?.lastFreeAnalysisDate||null} onFreeAnalysisUsed={()=>setProfile(p=>({...p,freeAnalysesUsed:(p?.freeAnalysesUsed||0)+1,lastFreeAnalysisDate:new Date().toISOString()}))} onAiAnalysis={(id,result)=>{const toStore=result&&typeof result==="object"?{bilan:result.bilan,pointFort:result.pointFort,suggestion:result.suggestion,variante:result.variante}:result;setSessions(p=>p.map(s=>s.id===id?{...s,aiAnalysis:toStore}:s));}} onApplySuggestions={handleApplySuggestions} prevSessions={sessions.filter(s=>s.programId===summarySession?.programId&&s.id!==summarySession?.id&&(s.type==="muscu"||!s.type)).slice(-4)} onClose={(note)=>{
  if(note){setSessions(p=>p.map(s=>s.id===summarySession.id?{...s,note}:s));}
  setSummarySession(null);setActive(null);setPage("home");
}} C={C}/>}
      {summarySession&&<div ref={shareCardRef} style={{position:'fixed',left:'-9999px',top:0,width:390,height:693,overflow:'hidden',zIndex:-1,pointerEvents:'none'}}>{summarySession.type==='tabata'?<ShareCardTabata session={summarySession} level={getLevelFromXP(totalXP)}/>:<ShareCard session={summarySession} totalSessions={sessions.length} weekStreak={streak} level={getLevelFromXP(totalXP)}/>}</div>}
      {!showOnboarding&&!summarySession&&page==="home"&&showGeneratePage&&(
        <GenerateProgramPage
          key={showGeneratePage ? "open" : "closed"}
          profile={profile}
          sessions={sessions}
          prs={prs}
          exerciseWeights={exerciseWeights}
          onGenerated={(generated, params)=>{
            const customProgs = programs.filter(p => p.isCustom);
            const withIds = generated.map(pr => ({...pr, id: Date.now()+Math.random()}));
            setPrograms([...customProgs, ...withIds]);
            if(params && typeof params === "object") setProfile(p => ({...p, ...params}));
            setShowGeneratePage(false);
            setHomeProgTab("generated");
            setHomeSwipePage(1);
          }}
          onBack={()=>setShowGeneratePage(false)}
          C={C}
        />
      )}
      {!showOnboarding&&!summarySession&&page==="home"&&<HomePage programs={programs} sessions={sessions} profile={profile} streak={streak} dataReady={cloudLoaded||guestMode} onCreateProgram={(groupName)=>{setEditProg(null);setHomeProgTab("custom");setHomeSwipePage(1);setPage("create");if(groupName)setSelectedGroupName(groupName);}} onStartSession={p=>{setActive(p);setPage("session");}} onEditProgram={p=>{setEditProg(p);setHomeProgTab("custom");setHomeSwipePage(1);setPage("create");}} onDeleteProgram={id=>setPrograms(p=>p.filter(x=>x.id!==id))} selectedGroupName={selectedGroupName} onSelectGroup={g=>setSelectedGroupName(g)} customGroupNames={customGroupNames} onAddCustomGroup={g=>{setCustomGroupNames(p=>p.includes(g)?p:[...p,g]);setSelectedGroupName(g);}} onReorderGroup={(groupName, reordered)=>{setPrograms(p=>[...p.filter(x=>x.groupName!==groupName),...reordered]);}} onRenameGroup={(oldName, newName)=>{setPrograms(p=>p.map(x=>x.groupName===oldName?{...x,groupName:newName}:x));setCustomGroupNames(p=>p.map(n=>n===oldName?newName:n));}} onDeleteGroup={g=>{setPrograms(p=>p.filter(x=>x.groupName!==g));setCustomGroupNames(p=>p.filter(n=>n!==g));setSelectedGroupName(prev=>{const remaining=[...new Set(programs.filter(p=>p.groupName&&p.groupName!==g).map(p=>p.groupName))];return remaining[0]||null;});}} progTab={homeProgTab} onChangeProgTab={setHomeProgTab} swipePage={homeSwipePage} onChangeSwipePage={setHomeSwipePage} defaultProgramId={defaultProgramId} onSetDefault={g=>setDefaultProgramId(p=>p===g?null:g)} onSaveProfile={p=>{const customProgs=programs.filter(prog=>prog.isCustom);const generated=generateAdaptedPrograms(p.duration||60,p.days,p.gender,p.equipment,p.homeEquip,exerciseWeights);setProfile(p);setPrograms([...customProgs,...generated.map(pr=>({...pr,id:Date.now()+Math.random()}))]);}} onGenerateProgram={()=>{setHomeSwipePage(1);setShowGeneratePage(true);}} prs={prs} newMedalKey={newMedalKey} onClearMedal={()=>setNewMedalKey(null)} totalXP={totalXP} tutorialRefs={tutorialRefs} onAiAnalysis={(id,text)=>{setSessions(p=>p.map(s=>s.id===id?{...s,aiAnalysis:text}:s));}} fitnessGoal={profile?.fitnessGoal||null} freeAnalysesUsed={profile?.freeAnalysesUsed||0} lastFreeAnalysisDate={profile?.lastFreeAnalysisDate||null} onFreeAnalysisUsed={()=>setProfile(p=>({...p,freeAnalysesUsed:(p?.freeAnalysesUsed||0)+1,lastFreeAnalysisDate:new Date().toISOString()}))} onApplySuggestions={handleApplySuggestions} C={C}/> }
      {page==="create"&&<CreateProgramPage existing={editProgram} targetGroupName={selectedGroupName} onSave={result=>{if(Array.isArray(result)){if(!result.length)return;const gName=result[0]?.groupName;if(gName){setCustomGroupNames(prev=>prev.includes(gName)?prev:[...prev,gName]);setSelectedGroupName(gName);}setPrograms(prev=>[...prev,...result]);}else{if(!result)return;setPrograms(prev=>editProgram?prev.map(x=>x.id===result.id?result:x):[...prev,result]);}setHomeProgTab("custom");setHomeSwipePage(1);setPage("home");}} onBack={()=>{setHomeProgTab("custom");setHomeSwipePage(1);setPage("home");}} C={C}/>}
      {!summarySession&&page==="session"&&activeProgram&&<SessionPage program={activeProgram} globalRestTime={90} voiceEnabled={voice} onFinish={s=>{
  if(s){
    const xpGained = calcSessionXP(s, sessions, profile?.days || 3);
    const prevLevel = getLevelFromXP(totalXP);
    const nextLevel = getLevelFromXP(totalXP + xpGained);
    const prevMedalKey = getMedalByLevel(prevLevel)?.label || null;
    const nextMedalKey = getMedalByLevel(nextLevel)?.label || null;
    if(nextMedalKey && nextMedalKey !== prevMedalKey) setNewMedalKey(nextMedalKey);
    setTotalXP(x => x + xpGained);
    const sessionWithXP = {...s, xpGained, programId: s.programId||activeProgram?.id, programName: s.programName||activeProgram?.name};
    setSessions(p=>[...p,sessionWithXP]);
    setSummarySession(sessionWithXP);
    // Nettoyer le flag aiSuggested après séance terminée
    setPrograms(prev=>prev.map(prog=>{
      if(prog.id!==(s.programId||activeProgram?.id)) return prog;
      return {...prog,exercises:(prog.exercises||[]).map(ex=>({...ex,plannedSets:(ex.plannedSets||[]).map(({aiSuggested:_,...set})=>set)}))};
    }));
    setExerciseWeights(prev=>{
      const updated={...prev};
      (s.exercises||[]).forEach(ex=>{
        if(!ex.name||!ex.sets?.length)return;
        const maxW=Math.max(...ex.sets.filter(st=>st.weight>0).map(st=>st.weight),-Infinity);
        if(maxW>0) updated[ex.name]=maxW;
      });
      return updated;
    });
  } else {
    setActive(null);setPage("home");
  }
}} prevSessions={sessions.filter(s=>s.programId===activeProgram.id)} prs={prs} exerciseWeights={exerciseWeights} C={C}/> }
      {page==="tabata"&&<TabataPage tabatas={tabatas} onCreateTabata={()=>{setEditTabata(null);setPage("createTabata");}} onGenerateTabata={()=>setPage("generateTabata")} onStartTabata={t=>{setActiveTab(t);setPage("runTabata");}} onEditTabata={t=>{setEditTabata(t);setPage("createTabata");}} onDeleteTabata={id=>setTabatas(p=>p.filter(x=>x.id!==id))} tutorialRefs={tutorialRefs} C={C}/>}
      {page==="createTabata"&&<CreateTabataPage onSave={t=>{setTabatas(prev=>editTabata?prev.map(x=>x.id===t.id?t:x):[...prev,t]);setPage("tabata");}} onBack={()=>setPage("tabata")} editingTabata={editTabata} onDelete={id=>{setTabatas(p=>p.filter(x=>x.id!==id));setPage("tabata");}} C={C}/>}
      {page==="generateTabata"&&<GenerateTabataPage onSave={t=>{setTabatas(prev=>[...prev,t]);setActiveTab(t);setPage("runTabata");}} onBack={()=>setPage("tabata")} C={C}/>}
      {page==="runTabata"&&activeTabata&&<TabataRunPage program={activeTabata} onFinish={()=>{setActiveTab(null);setPage("tabata");}} onSaveSession={s=>{const xpT=calcTabataXP();setTotalXP(x=>x+xpT);const sT={...s,xpGained:xpT};setSessions(p=>[...p,sT]);setActiveTab(null);setSummarySession(sT);}} C={C}/>}
      {page==="suivi"&&<SuiviPage key={suiviResetKey} sessions={sessions} measurements={measurements} totalXP={totalXP}
        onAddMeasurement={m=>setMeasurements(p=>[...p,m])}
        onDeleteMeasurement={(k,date)=>{
  if(date){
    setMeasurements(p=>p.map(m=>{
      if(m.date!==date)return m;
      const n={...m};delete n[k];return n;
    }).filter(m=>Object.keys(m).some(x=>x!=="date"&&m[x]!=null)));
  } else {
    setMeasurements(p=>p.map(m=>{const n={...m};delete n[k];return n;}).filter(m=>m.weight||Object.keys(m).some(x=>x!=="date"&&m[x])));
  }
}}
        prs={prs} onSavePR={onSavePR}
        onDeletePR={name=>setPRs(p=>{const n={...p};delete n[name];return n;})}
        onDeleteSession={id=>{
          const session = sessions.find(s=>s.id===id);
          if(session?.xpGained>0) setTotalXP(x=>Math.max(0, x - session.xpGained));
          setSessions(p=>p.filter(s=>s.id!==id));
        }}
        C={C}/>}
      {page==="profile"&&<ProfilePage profile={profile} sessions={sessions} prs={prs} totalXP={totalXP} programs={programs} defaultProgramId={defaultProgramId} voiceEnabled={voice} themeId={themeId} onSetTheme={setThemeId} darkMode={darkMode} onToggleDark={()=>setDarkManual(v=> v!=null ? !v : !darkMode)} user={user} onSignOut={handleSignOut} onSave={p=>{
  const prev=profile;
  setProfile(p);
  
  // Détecter si équipement a changé
  const equipmentChanged = prev && (
    prev.equipment!==p.equipment ||
    JSON.stringify(prev.homeEquip||[])!==JSON.stringify(p.homeEquip||[])
  );
  
  
  // Vérifier si une régénération des programmes est nécessaire
  const needsRegen = equipmentChanged || (p.days && (
    !prev ||
    (prev.equipment === "maison" && p.equipment === "salle") ||
    prev.duration !== p.duration ||
    prev.days !== p.days ||
    prev.gender !== p.gender
  ));

  if(needsRegen){
    const customProgs = programs.filter(prog => prog.isCustom);
    const generated = generateAdaptedPrograms(p.duration || 60, p.days, p.gender, p.equipment, p.homeEquip, exerciseWeights);
    // S'il y a des programmes générés existants → demander confirmation
    const hasExistingGenerated = programs.some(prog => !prog.isCustom);
    if(hasExistingGenerated){
      setPendingProfileRegen({profile:p, customPrograms:customProgs, generated});
      return; // Ne pas sauvegarder encore
    } else {
      setPrograms([...customProgs, ...generated.map(pr=>({...pr,id:Date.now()+Math.random()}))]);
    }
  }
  // Rester sur le profil après sauvegarde
}} onToggleVoice={()=>setVoice(v=>!v)} onReset={handleReset} onLogin={()=>signInWithPopup(fbAuth,googleProvider).catch(()=>{})} streak={streak} onRestartTutorial={()=>{setPage("home");setShowTutorial(true);}} C={C}/>}

      <ToastContainer/>
      {showResumeModal&&activeProgram&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:500,padding:"0 24px"}}>
          <div style={{background:C.card,borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:380,border:`1px solid ${C.border}`}}>
            <img src={LOGO_LIGHT_DATA} alt="Calestan" style={{height:40,objectFit:"contain",display:"block",margin:"0 auto 20px"}}/>
            <p style={{color:C.accent,fontSize:10,letterSpacing:3,fontWeight:700,margin:"0 0 8px",textAlign:"center"}}>SÉANCE EN COURS</p>
            <p style={{color:C.text,fontWeight:900,fontSize:18,margin:"0 0 6px",textAlign:"center"}}>{activeProgram.name}</p>
            <p style={{color:C.muted,fontSize:13,margin:"0 0 24px",textAlign:"center",lineHeight:1.5}}>Tu as une séance en cours. Que veux-tu faire ?</p>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button onClick={()=>{setShowResumeModal(false);setPage("session");}} style={{padding:"14px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}}>
                Reprendre la séance
              </button>
              <button onClick={()=>setShowResumeModal("confirm")} style={{padding:"14px",background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.25)",borderRadius:12,color:C.red,fontWeight:800,fontSize:15,cursor:"pointer"}}>
                Abandonner la séance
              </button>
            </div>
          </div>
        </div>
      )}
      {showResumeModal==="confirm"&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:500,padding:"0 24px"}}>
          <div style={{background:C.card,borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:380,border:`1px solid ${C.border}`}}>
            <p style={{color:C.text,fontWeight:900,fontSize:17,margin:"0 0 8px",textAlign:"center"}}>Abandonner la séance ?</p>
            <p style={{color:C.muted,fontSize:13,margin:"0 0 24px",textAlign:"center",lineHeight:1.5}}>La progression sera perdue. Cette action est irréversible.</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <button onClick={()=>setShowResumeModal(true)} style={{padding:"13px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.muted,fontWeight:800,fontSize:14,cursor:"pointer"}}>
                Annuler
              </button>
              <button onClick={()=>{setShowResumeModal(false);try{localStorage.removeItem("calestan_session_state");}catch{}setActive(null);}} style={{padding:"13px",background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.25)",borderRadius:12,color:C.red,fontWeight:800,fontSize:14,cursor:"pointer"}}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
      {showResetConfirm&&<ConfirmModal message="Supprimer toutes les données ? Cette action est irréversible." onConfirm={confirmReset} onCancel={()=>setShowResetConfirm(false)} C={C}/>}
      {pendingProfileRegen&&(
        <ConfirmModal
          message="Tes paramètres d'entraînement ont changé. Regénérer les programmes automatiques ? Tes programmes personnalisés seront conservés."
          confirmLabel="Regénérer"
          cancelLabel="Garder les programmes"
          onConfirm={()=>{
            const {profile:p, customPrograms, generated} = pendingProfileRegen;
            setProfile(p);
            setPrograms([...customPrograms, ...generated.map(pr=>({...pr,id:Date.now()+Math.random()}))]);
            setPendingProfileRegen(null);
          }}
          onCancel={()=>{
            // Sauvegarder le profil sans toucher aux programmes
            setProfile(pendingProfileRegen.profile);
            setPendingProfileRegen(null);
          }}
          C={C}
        />
      )}
      
      {/* Rating Banner Modal */}
      {showRatingBanner&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={dismissRating}>
          <div onClick={e=>e.stopPropagation()} style={{background:C.card,borderRadius:20,padding:30,maxWidth:340,width:"100%",textAlign:"center",boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}>
            <h2 style={{color:C.text,fontSize:22,fontWeight:900,marginBottom:10}}>Vous aimez Calestan ?</h2>
            <p style={{color:C.muted,fontSize:14,marginBottom:20,lineHeight:1.5}}>Votre avis compte ! Aidez-nous à améliorer l'app en donnant votre avis.</p>
            <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:24}}>
              {[...Array(5)].map((_,i)=>(
                <span key={i} style={{fontSize:32,color:"#FFD700",filter:"drop-shadow(0 2px 4px rgba(255,215,0,0.3))"}}>★</span>
              ))}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={dismissRating} style={{flex:1,padding:"12px 0",background:"transparent",border:`2px solid ${C.border}`,borderRadius:12,color:C.text,fontWeight:700,fontSize:14,cursor:"pointer"}}>
                Plus tard
              </button>
              <button onClick={acceptRating} style={{flex:1,padding:"12px 0",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:12,color:"#FFF",fontWeight:700,fontSize:14,cursor:"pointer",boxShadow:`0 4px 12px ${C.accent}44`}}>
                Donner mon avis
              </button>
            </div>
          </div>
        </div>
      )}
      
      {!showOnboarding&&!summarySession&&!["session","create","createTabata","runTabata"].includes(page)&&(
        <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:480,background:navBg,backdropFilter:"blur(20px)",borderTop:`1px solid ${C.border}`,display:"flex",flexDirection:"column",zIndex:100}}>
          <div style={{display:"flex",flexDirection:"row"}}>
          {nav.map(item=>{
            const active=page===item.id;
            const navRef={home:navHomeRef,tabata:navTabataRef,suivi:navSuiviRef,profile:navProfileRef}[item.id];
            return(
              <button ref={navRef} key={item.id} onClick={()=>{setPage(item.id);if(item.id==="home")setHomeSwipePage(0);if(item.id==="suivi")setSuiviResetKey(k=>k+1);}} style={{flex:1,padding:"10px 6px 12px",background:active?"rgba(245,166,35,0.07)":"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4,borderRadius:8,transition:"background 0.2s"}}>
                {item.svg(active)}
                <span style={{fontSize:9,fontWeight:active?800:500,letterSpacing:0.6,color:active?C.accent:"#555"}}>{item.label.toUpperCase()}</span>
              </button>
            );
          })}
          </div>
          <div style={{height:20}}/>
        </div>
      )}
    </div>
  );
}
